import React from 'react'

class MetaBox extends React.PureComponent {
  render() {
    const { title, value, index } = this.props
    if(index !== undefined) {
      return (
        <div className={'mb-8 c-black087 body2 order-' + index}>
          <div>
            <span className="d-inline-block fw-bold pr-16">{title}:</span>
            <span>{value}</span>
          </div>
        </div>
      )
    } else {
      return (
        <div className="mb-8 c-black087 body2">
         <span className="d-inline-block fw-bold min-width-100">{title}:</span>
          {value}
        </div>
      )
    }
  }
}

export default MetaBox



// WEBPACK FOOTER //
// ./src/js/components/inputs/MetaBox.js